(function () {
  var attributionStorageKey = 'aoy_original_inquiry_attribution';
  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var inquiryStorageKey = 'aoy_original_inquiry_klaviyo';
  var klaviyoSiteId = 'VXRF48';
  var klaviyoListId = 'TsmJtt';
  var klaviyoRevision = '2026-07-15';

  function getFocusable(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function lockPage() {
    document.documentElement.classList.add('aoy-dialog-open');
  }

  function unlockPage() {
    if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('aoy-dialog-open');
  }

  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    dialog.dataset.returnFocus = trigger && trigger.id ? trigger.id : '';
    dialog.showModal();
    lockPage();

    window.requestAnimationFrame(function () {
      var preferred = dialog.querySelector('[data-aoy-inquiry-form-state]:not([hidden]) input[required]');
      var focusable = getFocusable(dialog);
      (preferred || focusable[0] || dialog).focus();
    });
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function trapFocus(dialog, event) {
    if (event.key !== 'Tab') return;
    var focusable = getFocusable(dialog);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function selectMedia(root, mediaId) {
    root.querySelectorAll('[data-aoy-media-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.aoyMediaPanel !== mediaId;
      if (panel.hidden) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    root.querySelectorAll('[data-aoy-media-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', thumb.dataset.aoyMediaThumb === mediaId ? 'true' : 'false');
    });
  }

  function syncStickyPurchase(root) {
    var mainButton = root.querySelector('.aoy-original-pdp__purchase form[data-type="add-to-cart-form"] [name="add"]');
    var stickyButton = root.querySelector('[data-aoy-sticky-purchase]');
    if (!mainButton || !stickyButton) return;
    stickyButton.disabled = mainButton.disabled;
  }

  function syncSelectedVariantMedia(root) {
    var form = root.querySelector('.aoy-original-pdp__purchase form[data-type="add-to-cart-form"]');
    var variantSelects = root.querySelector('variant-selects');
    var variantInput = form && form.querySelector('input[name="id"]');
    var variantDataNode = variantSelects && variantSelects.querySelector('script[type="application/json"]');
    if (!variantInput || !variantDataNode) return;
    try {
      var variants = JSON.parse(variantDataNode.textContent);
      var variant = variants.find(function (item) { return String(item.id) === String(variantInput.value); });
      root.dataset.variantId = variantInput.value;
      if (variant && variant.featured_media && variant.featured_media.id) selectMedia(root, String(variant.featured_media.id));
    } catch (error) {
      // Leave the current media intact if variant JSON is unavailable.
    }
  }

  function submitMainProductForm(root) {
    var form = root.querySelector('.aoy-original-pdp__purchase form[data-type="add-to-cart-form"]');
    var button = form && form.querySelector('[name="add"]');
    if (!form || !button || button.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
    else button.click();
  }

  function getAttribution() {
    var attribution = {};
    try {
      var stored = window.sessionStorage.getItem(attributionStorageKey);
      if (stored) attribution = JSON.parse(stored) || {};
    } catch (error) {
      attribution = {};
    }
    var params = new URLSearchParams(window.location.search);
    attributionKeys.forEach(function (key) {
      if (params.has(key)) attribution[key] = params.get(key) || '';
      if (typeof attribution[key] !== 'string') attribution[key] = '';
    });
    return attribution;
  }

  function dispatchInquirySuccess(dialog) {
    var attribution = getAttribution();
    document.dispatchEvent(new CustomEvent('artofyost:original_inquiry_submitted', {
      detail: {
        product_id: dialog.dataset.aoyProductId,
        product_handle: dialog.dataset.aoyProductHandle,
        artwork_title: dialog.dataset.aoyArtworkTitle,
        page_path: window.location.pathname,
        utm_source: attribution.utm_source,
        utm_medium: attribution.utm_medium,
        utm_campaign: attribution.utm_campaign,
        utm_content: attribution.utm_content,
        utm_term: attribution.utm_term
      }
    }));
  }

  function setInquirySubmitState(form) {
    var button = form && form.querySelector('#original-art-inquiry-submit');
    var label = button && button.querySelector('[data-aoy-submit-label]');
    if (!button || !label) return;
    button.disabled = true;
    label.textContent = 'Sending…';
  }

  function createInquiryId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'aoy-inquiry-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function storePendingInquiry(form, dialog, marketingConsent) {
    var email = form.querySelector('#original-art-inquiry-email');
    if (!email || !email.value) return;

    try {
      window.sessionStorage.setItem(inquiryStorageKey, JSON.stringify({
        inquiryId: createInquiryId(),
        email: email.value.trim(),
        marketingConsent: Boolean(marketingConsent && marketingConsent.checked),
        artworkTitle: dialog.dataset.aoyArtworkTitle || '',
        productId: dialog.dataset.aoyProductId || '',
        productHandle: dialog.dataset.aoyProductHandle || ''
      }));
    } catch (error) {
      // Storage failure must never interrupt Shopify's native contact form submission.
    }
  }

  function sendKlaviyoRequest(endpoint, body) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '?company_id=' + encodeURIComponent(klaviyoSiteId), {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        revision: klaviyoRevision
      },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo ' + endpoint + ' request failed with HTTP ' + response.status);
    });
  }

  function logKlaviyoSuccess(action) {
    console.info('[Art of Yost] Klaviyo ' + action + ' succeeded.');
  }

  function logKlaviyoFailure(action, error) {
    console.error('[Art of Yost] Klaviyo ' + action + ' failed.', error);
  }

  function sendInquiryEvent(inquiry) {
    return sendKlaviyoRequest('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            'Artwork Title': inquiry.artworkTitle,
            'Product ID': inquiry.productId,
            'Product Handle': inquiry.productHandle
          },
          unique_id: inquiry.inquiryId,
          metric: {
            data: {
              type: 'metric',
              attributes: { name: 'Original Art Inquiry Submitted' }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: { email: inquiry.email }
            }
          }
        }
      }
    });
  }

  function recordInquiryEmailConsent(inquiry) {
    return sendKlaviyoRequest('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Original Art Inquiry',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: inquiry.email,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: klaviyoListId }
          }
        }
      }
    });
  }

  function subscribeInquiryEmailToList(inquiry) {
    var body = new URLSearchParams();
    body.set('g', klaviyoListId);
    body.set('email', inquiry.email);

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: body.toString(),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo Email List request failed with HTTP ' + response.status);
      return response.json();
    }).then(function (result) {
      if (!result || result.success !== true) {
        var errors = result && Array.isArray(result.errors) ? result.errors.join(', ') : 'Unknown response';
        throw new Error('Klaviyo Email List request was rejected: ' + errors);
      }
      return result;
    });
  }

  function processPendingInquiry() {
    if (!document.querySelector('[data-aoy-inquiry-received]')) return;

    var inquiry;
    try {
      var storedInquiry = window.sessionStorage.getItem(inquiryStorageKey);
      if (!storedInquiry) return;
      window.sessionStorage.removeItem(inquiryStorageKey);
      inquiry = JSON.parse(storedInquiry);
    } catch (error) {
      try { window.sessionStorage.removeItem(inquiryStorageKey); } catch (storageError) {}
      return;
    }

    if (!inquiry || !inquiry.email || !inquiry.inquiryId) return;

    sendInquiryEvent(inquiry).then(function () {
      logKlaviyoSuccess('inquiry event');
    }).catch(function (error) {
      logKlaviyoFailure('inquiry event', error);
    });

    if (inquiry.marketingConsent === true) {
      recordInquiryEmailConsent(inquiry).then(function () {
        logKlaviyoSuccess('email consent');
      }).catch(function (error) {
        logKlaviyoFailure('email consent', error);
      });

      subscribeInquiryEmailToList(inquiry).then(function () {
        logKlaviyoSuccess('Email List subscription');
      }).catch(function (error) {
        logKlaviyoFailure('Email List subscription', error);
      });
    }
  }

  function initInquirySubmission(dialog) {
    if (!dialog) return;
    var form = dialog.querySelector('#original-art-inquiry-form');
    var marketingConsent = form && form.querySelector('[data-aoy-marketing-consent]');
    var marketingConsentValue = form && form.querySelector('[data-aoy-marketing-consent-value]');
    if (!form || form.dataset.aoyInquirySubmissionReady === 'true') return;
    form.dataset.aoyInquirySubmissionReady = 'true';

    if (marketingConsent && marketingConsentValue) {
      marketingConsent.addEventListener('change', function () {
        marketingConsentValue.value = marketingConsent.checked ? 'Yes' : 'No';
      });
    }

    form.addEventListener('submit', function () {
      if (marketingConsentValue) marketingConsentValue.value = marketingConsent && marketingConsent.checked ? 'Yes' : 'No';
      storePendingInquiry(form, dialog, marketingConsent);
      setInquirySubmitState(form);
    });

    var success = dialog.querySelector('#original-art-inquiry-success[data-aoy-inquiry-primary-success="true"]');
    var error = dialog.querySelector('#original-art-inquiry-error:not([hidden])');
    if (success || error) {
      openDialog(dialog, null);
      if (success && dialog.dataset.aoyInquirySuccessDispatched !== 'true') {
        dialog.dataset.aoyInquirySuccessDispatched = 'true';
        dispatchInquirySuccess(dialog);
        window.requestAnimationFrame(function () { success.focus(); });
      }
    }

    var returnButton = dialog.querySelector('[data-aoy-inquiry-return]');
    if (returnButton) returnButton.addEventListener('click', function () { closeDialog(dialog); });
  }

  function initOriginalPdp(root) {
    if (!root || root.dataset.aoyOriginalReady === 'true') return;
    root.dataset.aoyOriginalReady = 'true';

    root.querySelectorAll('[data-aoy-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectMedia(root, thumb.dataset.aoyMediaThumb); });
    });

    var gallery = root.querySelector('[id^="gallery-main-product-"]');
    if (gallery && !gallery.swiper) gallery.swiper = { initialized: false };

    var zoomDialog = root.querySelector('[data-aoy-zoom-dialog]');
    root.querySelectorAll('[data-aoy-zoom-open]').forEach(function (trigger, index) {
      if (!trigger.id) trigger.id = 'AoyOriginalZoomTrigger-' + index;
      trigger.addEventListener('click', function () {
        var mediaId = trigger.dataset.aoyZoomOpen;
        if (zoomDialog) zoomDialog.querySelectorAll('[data-aoy-zoom-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.aoyZoomPanel !== mediaId;
        });
        openDialog(zoomDialog, trigger);
      });
    });

    var inquiryDialog = root.querySelector('#original-art-inquiry-modal');
    initInquirySubmission(inquiryDialog);
    root.querySelectorAll('[data-aoy-inquiry-open]').forEach(function (trigger, index) {
      if (!trigger.id) trigger.id = 'AoyOriginalInquiryTrigger-' + index;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'original-art-inquiry-modal');
      trigger.addEventListener('click', function () {
        openDialog(inquiryDialog, trigger);
      });
    });

    root.querySelectorAll('[data-aoy-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeDialog(button.closest('dialog')); });
    });

    root.querySelectorAll('dialog').forEach(function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });
      dialog.addEventListener('keydown', function (event) { trapFocus(dialog, event); });
      dialog.addEventListener('close', function () {
        unlockPage();
        var returnFocusId = dialog.dataset.returnFocus;
        var returnFocus = returnFocusId && document.getElementById(returnFocusId);
        if (returnFocus) returnFocus.focus();
        else if (dialog === inquiryDialog) {
          var artwork = document.getElementById('aoy-original-main');
          if (artwork) {
            artwork.setAttribute('tabindex', '-1');
            artwork.focus();
          }
        }
      });
    });

    var sticky = root.querySelector('[data-aoy-original-sticky]');
    var panel = root.querySelector('[data-aoy-original-panel]');
    if (sticky && panel && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      observer.observe(panel);
    }

    var stickyPurchase = root.querySelector('[data-aoy-sticky-purchase]');
    if (stickyPurchase) stickyPurchase.addEventListener('click', function () { submitMainProductForm(root); });

    syncStickyPurchase(root);
    syncSelectedVariantMedia(root);
    root.addEventListener('change', function () {
      window.requestAnimationFrame(function () {
        syncStickyPurchase(root);
        syncSelectedVariantMedia(root);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.aoy-original-pdp[data-pdp-type="original"]').forEach(initOriginalPdp);
    processPendingInquiry();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('variant-update', function () {
    window.requestAnimationFrame(function () {
      document.querySelectorAll('.aoy-original-pdp[data-pdp-type="original"]').forEach(syncStickyPurchase);
      document.querySelectorAll('.aoy-original-pdp[data-pdp-type="original"]').forEach(syncSelectedVariantMedia);
    });
  });
  document.addEventListener('shopify:section:load', initAll);
})();
